import { GoogleOAuthProvider } from "@react-oauth/google";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "antd/dist/antd.less";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import reportWebVitals from "reportWebVitals";
import App from "./app/App";
import store from "./app/store";
import "./styles.scss";
const root = ReactDOM.createRoot(document.getElementById("root"));
const clientId =
  "320924852787-5uggqbp1pvj1mnroif9b5v80p9proo4i.apps.googleusercontent.com";
const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 1000 * 60 * 10 } },
});

root.render(
  <GoogleOAuthProvider clientId={clientId}>
    {/* <React.StrictMode> */}
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <Router>
            <App />
          </Router>
        </Provider>
      </QueryClientProvider>
    {/* </React.StrictMode> */}
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
